import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Confirm, Header, Form, Icon, Tab } from 'semantic-ui-react'
import Details from './office/details'
import Images from './office/images'
import Messages from '../Messages.js'
import { inlineStyle } from '../../styles/custom'
import { languages } from '../../constants'
import PermissionsManager from '../PermissionsManager'

const renderPanes = (obj, onChange) => {
  let panes = languages.map((language) => {
    const attrs = {obj: obj, language: language, onChange: onChange}
    return {menuItem: language.label, render: () => <Tab.Pane key={language.code} attached={false}><Details {...attrs} /></Tab.Pane>}
  })

  panes.push({menuItem: 'Gestion des images', render: () => <Tab.Pane attached={false}><Images obj={obj} onChange={onChange} /></Tab.Pane>})

  return panes
}

const OfficeForm = ({ obj, status, onChange, onSubmit, onDelete }) => {

  return (
    <Form>
      <Header>Bureau{status.isNew ? ' : Création' : ' : Édition'}</Header>
      <Messages errors={status.errors} />
      <Tab menu={{ pointing: true }} panes={renderPanes(obj, onChange)} />
      <br /><br />
      <Form.Field>
        <PermissionsManager hasPermissions={['create_office', 'update_office']}>
          {status.loading ? <Button type='submit' floated='left' color='red' loading> Chargement...</Button> :
            <Button type='submit' floated='left' color='olive' onClick={onSubmit}><Icon name="save" /> Sauvegarder</Button>
          }
        </PermissionsManager>
        <PermissionsManager hasPermissions={['create_social_network', 'update_social_network', 'delete_social_network']}>
          {!status.isNew ? (
            <div>
              <Link to={`/offices/${obj.id}/social-networks`} floated='right' className='ui button olive'><Icon name="discussions" /> Gestion des réseaux sociaux</Link>
            </div>
          ) : null}
        </PermissionsManager>
        <PermissionsManager hasPermissions={['delete_office']}>
          {!status.isNew ? (
            <div>
              <Button type='submit' color='red' floated='right' onClick={(office, data) => { onDelete(office, { confirm: true }) }}><Icon name="delete" /> Suppression</Button>
            </div>
          ) : null}
        </PermissionsManager>
      </Form.Field>
      <Confirm
        content='Êtes-vous sûr(e) de vouloir supprimer ce bureau ? Cette action est définitive.'
        open={status.deletion.confirm} onCancel={(office, data) => { onDelete(office, { confirm: null }) }}
        onConfirm={(office, data) => { onDelete(office, { confirm: false }) }} style={inlineStyle.modal}
        cancelButton='Annuler'
        confirmButton='Ok'
      />
    </Form>
  )
}

export default OfficeForm



// WEBPACK FOOTER //
// ./src/components/form/Office.js